import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'descDataFilter',
})
export class descPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    if (query) {
      return _.filter(array, (row) => 
        (row.description.toLowerCase().indexOf(query.toLowerCase()) > -1 || row.customerMobile.indexOf(query.toLowerCase().replaceAll(" ","")) > -1 || row.code.toLowerCase().indexOf(query.toLowerCase()) > -1)
      );
    }
    return array;
  }
}


